'use client';

import Image from 'next/image';
import Link from 'next/link';
import { motion } from 'framer-motion';
import { Sparkles, ArrowRight, CheckCircle2 } from 'lucide-react';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

function cn(...inputs: ClassValue[]) {
      return twMerge(clsx(inputs));
}

const GynoLiveSection = () => {
      return (
            <section className="relative w-full py-24 lg:py-32 bg-[#FAFAFA] overflow-hidden">

                  <div className="absolute right-[-5%] bottom-[-10%] w-100 h-100 bg-pink-400/10 rounded-full blur-[100px] pointer-events-none" />

                  <div className="container mx-auto px-6 relative z-10">
                        <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-24">

                              <motion.div
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ duration: 0.8, ease: "easeOut" }}
                                    className="w-full lg:w-1/2 flex justify-center lg:justify-end"
                              >
                                    <motion.div
                                          animate={{ y: [-10, 10, -10] }}
                                          transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
                                          // 1. ADIM: overflow-hidden ekledik. 
                                          // Böylece resim büyüse de bu karenin dışına taşmaz.
                                          className="relative w-full aspect-square overflow-hidden"
                                    >
                                          <Image
                                                src="/gyno-live-phone.png"
                                                alt="Gyno Life Experience"
                                                fill
                                                // 2. ADIM: scale-[1.5] ekledik. (scale=1.5 prop'u yerine)
                                                // scale-[1.5] -> transform: scale(1.5) demektir.
                                                // className="object-contain scale-[1.5]"
                                                priority
                                          />
                                    </motion.div>
                              </motion.div>

                              <motion.div
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
                                    className="w-full lg:w-1/2 flex flex-col items-start text-left"
                              >
                                    <div className="mb-6 inline-flex items-center justify-center w-12 h-12 rounded-2xl bg-white shadow-sm border border-purple-100 text-[#6320EE]">
                                          <Sparkles className="w-6 h-6" />
                                    </div>

                                    <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
                                          Gyno Life&apos;a Katıl, <br />
                                          <span className="text-transparent bg-clip-text bg-linear-to-r from-[#6320EE] to-[#DA38E2]">
                                                Kendini Yeniden Keşfet.
                                          </span>
                                    </h2>

                                    <p className="text-gray-600 text-lg leading-relaxed mb-8 max-w-lg">
                                          Hayatınıza yeni bir yön vermek, sağlıklı alışkanlıklar kazanmak ve size özel deneyimlerle gününüzü güzelleştirmek için buradayız. Gyno Life, sadece bir uygulama değil; sizin en iyi versiyonunuza giden yolculuktur.
                                    </p>

                                    <ul className="space-y-4 mb-10">
                                          {[
                                                "Kişiselleştirilmiş Wellness Takibi",
                                                "Günlük Astroloji ve Enerji Rehberliği",
                                                "Size Özel Premium İçerikler"
                                          ].map((item, i) => (
                                                <li key={i} className="flex items-center gap-3 text-gray-700 font-medium">
                                                      <CheckCircle2 className="w-5 h-5 text-[#DA38E2]" />
                                                      {item}
                                                </li>
                                          ))}
                                    </ul>

                                    <Link href="https://gynoclub.com.tr/app" target="_blank" className="group flex items-center gap-2 text-[#6320EE] font-bold text-lg hover:gap-4 transition-all duration-300">
                                          <span>Hemen Başla</span>
                                          <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
                                    </Link>

                              </motion.div>

                        </div>
                  </div>
            </section>
      );
};

export default GynoLiveSection;